import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css'; // Asegúrate de importar Bootstrap
import 'bootstrap-icons/font/bootstrap-icons.css'; // Importa Bootstrap Icons

ReactDOM.render(<App />, document.getElementById('root'));
